<template>
  <sec-section hero :divider="false" labelledby="about-hero-title">
    <div class="about-hero">
      <div class="about-hero__copy">
        <h1 id="about-hero-title" class="o600 sec-h1 about-hero__title" data-reveal>
          <template v-for="(line, i) in hero.titleLines" :key="line">{{ line }}<br v-if="i < hero.titleLines.length - 1" /></template>
        </h1>
        <p v-for="p in hero.paragraphs" :key="p" class="m500 sec-lede about-hero__text" data-reveal>{{ p }}</p>
      </div>

      <div class="about-hero__card" data-reveal>
        <p class="o700 sec-eyebrow">{{ hero.nameCard.eyebrow }}</p>
        <div class="about-hero__letters">
          <div v-for="row in hero.nameCard.letters" :key="row.letter" class="about-hero__row">
            <span class="o700 about-hero__letter">{{ row.letter }}</span>
            <span class="o600 about-hero__word">
              <span v-if="row.prefix" class="about-hero__prefix">{{ row.prefix }}</span>{{ row.word }}
            </span>
          </div>
        </div>
        <p class="o600 about-hero__full">{{ hero.nameCard.full }}</p>
      </div>
    </div>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import { ABOUT } from '@/content/security/about';

const hero = ABOUT.hero;
</script>

<style scoped>
.about-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 3.5rem;
}

.about-hero__copy {
  flex: 999 1 560px;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.about-hero__title {
  margin-bottom: 1.75rem;
}

.about-hero__text {
  max-width: 720px;
}

.about-hero__text + .about-hero__text {
  margin-top: 1.125rem;
}

.about-hero__card {
  flex: 1 1 320px;
  padding: 2rem 2.25rem;
  background: var(--sec-surface);
  border: 1px solid var(--sec-line);
  border-radius: var(--sec-radius-card);
}

.about-hero__letters {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 1.25rem;
}

.about-hero__row {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}

.about-hero__letter {
  width: 40px;
  font-size: 2.75rem;
  line-height: 1;
  color: var(--sec-accent-hover);
}

.about-hero__word {
  font-size: 1.625rem;
  color: var(--sec-ink);
}

.about-hero__prefix {
  font-weight: 500;
  color: var(--sec-ink-3);
}

.about-hero__full {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--sec-line);
  font-size: 1.125rem;
  line-height: 1.45;
  color: var(--sec-ink);
}
</style>
